import Stack from '@perpay-web/components/design-system/Stack/Stack';
import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './IdentityDetailsBlock.scss';

const IdentityDetailsBlock = ({
    firstName,
    lastName,
    dateOfBirth,
    ssn,
    className = '',
}) => (
    <Stack className={getClassName(styles.wrapper, className)}>
        <Stack className={styles.detail}>
            <div className={styles.label}>Name</div>
            <div className={styles.value}>
                {firstName} {lastName}
            </div>
        </Stack>
        <Stack className={styles.detail}>
            <div className={styles.label}>Social Security Number</div>
            <div className={styles.value}>{ssn}</div>
        </Stack>
        <Stack className={styles.detail}>
            <div className={styles.label}>Birthday</div>
            <div className={styles.value}>{dateOfBirth}</div>
        </Stack>
    </Stack>
);

export default IdentityDetailsBlock;
